import React, { createContext, useContext, useState } from 'react';

const CrmAnalysisContext = createContext(null);

/**
 * Provides the currently-selected tenant for CRM analysis pages.
 * Populated when the admin clicks "CRM Analysis" in the tenant table.
 */
export function CrmAnalysisProvider({ children }) {
  const [selectedTenant, setSelectedTenant] = useState(null);
  // { id, name, domain }

  return (
    <CrmAnalysisContext.Provider value={{ selectedTenant, setSelectedTenant }}>
      {children}
    </CrmAnalysisContext.Provider>
  );
}

export function useCrmAnalysis() {
  const ctx = useContext(CrmAnalysisContext);
  if (!ctx) throw new Error('useCrmAnalysis must be used inside CrmAnalysisProvider');
  return ctx;
}
